'use strict';

module.exports = {
    TEST_STATE_UPDATED: 'test.state.updated'
};